export default "__VITE_ASSET__C9MXJz7k__"